module.exports = __webpack_public_path__ + "img/cartao.7a8fde42.svg";